import { DataTypeConfig } from "../../../../types";

export const systemsConfig: DataTypeConfig = {
  tabs: ["systemType", "status", "backupStatus", "operationalHours"],
  searchableColumns: [
    "System Name",
    "Facility ID",
    "System Type",
    "Status",
    "Backup Status",
    "Operational Hours",
    "Address/Site Label",
    "Description/Purpose",
  ],
  filterColumns: [
    { column: "System Type", type: "dropdown", label: "System Type" },
    { column: "Facility ID", type: "dropdown", label: "Facility ID" },
    { column: "Status", type: "dropdown", label: "Status" },
    { column: "Backup Status", type: "dropdown", label: "Backup Status" },
    {
      column: "Operational Hours",
      type: "dropdown",
      label: "Operational Hours",
    },
    {
      column: "Commissioned/Planned Date",
      type: "date",
      label: "Commissioned/Planned Date",
    },
    { column: "Design Capacity", type: "range", label: "Design Capacity" },
    {
      column: "Current Throughput",
      type: "range",
      label: "Current Throughput",
    },
  ],
  tableColumns: [
    { key: "systemName", header: "System Name", type: "custom" },
    { key: "facilityId", header: "Facility ID", type: "custom" },
    { key: "systemType", header: "System Type", type: "badge" },
    { key: "status", header: "Status", type: "badge" },
    { key: "backupStatus", header: "Backup Status", type: "badge" },
    { key: "operationalHours", header: "Operational Hours", type: "badge" },
    { key: "addressSiteLabel", header: "Address/Site Label", type: "custom" },
    {
      key: "descriptionPurpose",
      header: "Description/Purpose",
      type: "custom",
    },
    {
      key: "commissionedPlannedDate",
      header: "Commissioned/Planned Date",
      type: "custom",
    },
    { key: "latitude", header: "Latitude", type: "custom" },
    { key: "longitude", header: "Longitude", type: "custom" },
    { key: "designCapacity", header: "Design Capacity", type: "custom" },
    { key: "currentThroughput", header: "Current Throughput", type: "custom" },
  ],
  mandatoryFields: [
    "System Name",
    "Facility ID",
    "System Type",
    "Status",
    "Commissioned/Planned Date",
    "Backup Status",
    "Operational Hours",
    "Address/Site Label",
    "Latitude",
    "Longitude",
    "Description/Purpose",
    "Design Capacity",
    "Current Throughput",
  ],
};

export const systemsTabDisplayNames: Record<string, string> = {
  systemType: "System Type",
  status: "Status",
  backupStatus: "Backup Status",
  operationalHours: "Operational Hours",
};

export const systemsTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "systemType":
      return [
        { value: "distribution", label: "Distribution" },
        { value: "pumping", label: "Pumping" },
        { value: "treatment", label: "Treatment" },
        { value: "storage", label: "Storage" },
      ];
    case "status":
      return [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
        { value: "under_maintenance", label: "Under Maintenance" },
        { value: "planned", label: "Planned" },
      ];
    case "backupStatus":
      return [
        { value: "available", label: "Available" },
        { value: "not_available", label: "Not Available" },
        { value: "partial", label: "Partial" },
      ];
    case "operationalHours":
      return [
        { value: "24_7", label: "24/7" },
        { value: "6am_10pm", label: "6 AM - 10 PM" },
        { value: "8_hours", label: "8 Hours/Day" },
        { value: "on_demand", label: "On Demand" },
      ];
    default:
      return [];
  }
};
